<template>
  <div class="merchant-info-setting">
    <!-- <div class="flex-justify-between mb-24">
      <div class="setting-item-label text-14-500">{{ $t('merchant.merchant_logo') }}</div>
      <div class="setting-item-value text-14-500 color-488CE8">
        <div v-loading="uploadLoading" class="flex-justify-align-center">
          <el-image v-if="$store.getters.logoImgOssUrl" class="mr-12" style="width: 90px; height: 90px; border-radius: 50%; border: 1px solid #D3D7DF" :src="$store.getters.logoImgOssUrl" :preview-src-list="[$store.getters.logoImgOssUrl]" />
          <el-upload
            style="display: inline-block;"
            action="#"
            :auto-upload="false"
            :show-file-list="false"
            accept=".jpg,.jpeg,.png,.JPG,.JPEG,.PNG"
            :file-list="fileList"
            :on-change="handleImageChange"
          >
            <el-button size="mini" type="info" plain>{{ $t('tips.click_to_upload_image') }}</el-button>

          </el-upload>
        </div>

      </div>
    </div> -->

    <div class="flex-justify-between mb-24">
      <div class="setting-item-label text-14-500">{{ $t('merchant.merchant_no') }}</div>
      <div class="setting-item-value text-14-500 color-488CE8">
        {{ userInfo.merchant_no }}
      </div>
    </div>

    <div class="flex-justify-between mb-24">
      <div class="setting-item-label text-14-500">{{ $t('merchant.merchant_name') }}</div>
      <div class="setting-item-value text-14-500 color-488CE8">
        {{ userInfo.merchant_name }}
      </div>
    </div>

    <div class="flex-justify-between mb-24">
      <div class="setting-item-label text-14-500">{{ $t('merchant.merchant_type') }}</div>
      <div class="setting-item-value text-14-500 color-488CE8">
        {{ getMerchantTypeMap( userInfo.merchant_type) }}
      </div>
    </div>

    <div class="flex-justify-between mb-24">
      <div class="setting-item-label text-14-500">{{ $t('merchant.notification_email') }}</div>
      <div class="setting-item-value text-14-500 color-488CE8">
        {{ userInfo.merchant_basic_info.notification_email }}
      </div>
    </div>

    <div class="flex-justify-between mb-24">
      <div class="setting-item-label text-14-500">{{ $t('merchant.notification_phone') }}</div>
      <div class="setting-item-value text-14-500 color-488CE8">
        {{ userInfo.merchant_basic_info.notification_phone }}
      </div>
    </div>

    <div class="flex-justify-between mb-24">
      <div class="setting-item-label text-14-500">{{ $t('merchant.contract_effect_time') }}</div>
      <div class="setting-item-value text-14-500 color-488CE8">
        {{ userInfo.contract_validity_start }}   {{ userInfo.contract_validity_start? $t('merchant.to') : '-' }}   {{ userInfo.contract_validity_end }}
      </div>
    </div>

    <div class="flex-justify-between mb-24">
      <div class="setting-item-label text-14-500">{{ $t('merchant.merchant_status') }}</div>
      <div class="setting-item-value text-14-500 color-488CE8">
        {{ getMerchantStatusMap(userInfo.merchant_status) }}
      </div>
    </div>
  </div>
</template>

<script>
import { merchantTypeMap, merchantStatusMap } from '@/utils/maps'
import { getMerchantInfo } from '@/api/user'
import { uploadImg } from '@/api/components/upload'
import { updateMchLogoImg } from '@/api/merchant-manage/merchant-manage'
import serviceConst from '@/const/serviceConst.json'

export default {
  name: 'MerchantInfoItem',
  data() {
    return {
      userInfo: {
        merchant_basic_info: {}
      },
      merchantUser: this.$store.getters.userInfo,
      uploadLoading: false,
      fileList: [],
      pic_path: ''
    }
  },
  computed: {
    // userInfo() {
    //   const { userInfo } = this.$store.state.user
    //   return userInfo
    // },
    getMerchantTypeMap() {
      return function(value) {
        return merchantTypeMap(value).label
      }
    },
    getMerchantStatusMap() {
      return function(value) {
        return merchantStatusMap(value).label
      }
    },
    isHideUpdate() {
      return this.fileList && this.fileList.length > 0
    }
  },
  watch: {
    '$store.getters.logoImgOssUrl': {
      handler: function() {
        this.getMerchantLogo()
      },
      deep: true
    }
  },
  created() {
    this.getMerchant()
    this.getMerchantLogo()
  },
  methods: {
    getMerchant() {
      getMerchantInfo().then(response => {
        const { data } = response
        if (!data) {
          return this.$message({ message: 'Verification failed, please Login again.', type: 'warning' })
        }
        this.userInfo = data.merchant
      })
    },
    handleImageChange(file, fileList) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('The size of the uploaded image cannot exceed 2MB!')
        this.$store.dispatch('user/getInfo')
        return
      }

      if (this.uploadLoading) {
        this.$message.warning('Uploading, pls wait!')
        return
      }

      this.fileList = []

      this.uploadLoading = true
      const formData = new FormData()
      formData.append('business', 'MERCHANT_INFO')
      formData.append('file', file.raw)
      uploadImg(formData).then(res => {
        if (res.code === serviceConst.resCode.succ) {
          this.pic_path = res.data.path
          this.fileList = [file]
          this.updateMchLogo()
        }
      })
    },
    updateMchLogo() {
      const params = {
        logo_img: this.pic_path
      }
      updateMchLogoImg(params).then(res => {
        if (res.code === serviceConst.resCode.succ) {
          this.$message.success('Upload Logo Success')
        }
      }).finally(() => {
        this.$store.dispatch('user/getInfo').then(res => {})
        this.uploadLoading = false
      })
    }
  }

}
</script>

<style lang="scss" scoped>
  .sectionItem{
    &_title{
      margin-bottom: 32px;
      font-size: 18px;
      font-weight: 500;  font-family: 'Poppins-Medium';
      color: #3855F1;
    }
    &_name{
      margin-top: 24px;
      font-size: 16px;
      font-weight: 400;
      color: #4B5567;
    }
    &_a{
      font-size: 12px;
      line-height: 17px;
      color: #3579FF;
      text-decoration: underline;
    }
    .sectionItem_col-label{
      color: #98A1B4;
      display: inline-block;
      width: 200px;
    }
  }

  .update-head-img {
    text-align: left;
    vertical-align: top;
    &:hover{
      color: #3855F1;
    }
  }

  @media screen and (max-width: 376px) {
  .sectionItem_name{
    margin: 0;
  }
  .sectionItem_col{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
}

</style>
